module.exports = __webpack_public_path__ + "static/media/Nota Mayodipea tu antojo WEBP.d82a2a1f.webp";